export default {
  tabMenu: {
    audit: 'Audit',
    auditConfiguration: 'Špecifikácie auditu',
    quality: 'Kvalita',
    qualityConfiguration: 'Predvoľby kvality',
    qualityStatistics: 'Štatistiky kvality',
  },
};
